export const generateBasicPrompt = (tableName, columns) => {
    return `You are a SQL query generator. You will be given a table name and its columns.`
}

export const generateQueryPrompt = (tables, query) => {
    return `You are a SQL query generator. You will be given a list of tables and their columns, and a query.    
    Your task is to generate a SQL query based on the provided information.
    Tables:
    ${tables.map(table => `Table: ${table.tableName}, Columns: ${table.columns.map(col => "\"" + col.name + "\"").join(', ')}`).join('\n')}`
    + `\nQuery: ${query}\n`

}


export const getSQLResponseBlocks = (response) => {

    const sqlBlocks = [];
    const regex = /```sql\s*([\s\S]*?)```/g;

    let match;
    while ((match = regex.exec(response)) !== null) {
        sqlBlocks.push(match[1].trim());
    }

    console.log(sqlBlocks);

    return sqlBlocks;

}